export default class ProductTypeModel {
    constructor() {
        this.id = 0;
        this.name = "";
        this.icon = "";
        this.packageType = 1;
        this.packageTypeName = "";
    }
}
